import React from 'react';
import { Link } from 'react-router-dom';
import weddingGarlands from '../data/weddingGarlands';

export default function WeddingGarlands() {
  return (
    <section className="py-12 bg-[#fdfcf8] -mx-4 md:-mx-8 px-4 md:px-8">
      <div className="max-w-[1440px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h3 className="text-3xl font-extrabold tracking-tight">Wedding Garlands</h3>
            <p className="text-[#9a8d4c] font-medium">Bespoke artisanal garlands for your special moments</p>
          </div>
          <Link to="/products" className="flex items-center gap-1 font-bold text-primary hover:text-gold-dark transition-colors">
            View All
            <span className="material-symbols-outlined">chevron_right</span>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {weddingGarlands.map((g) => (
            <div key={g.id} className="bg-white p-5 rounded-2xl shadow-sm border border-[#e7e3cf] group flex gap-5">
              <div className="size-32 rounded-xl overflow-hidden shrink-0 shadow-inner">
                <img alt={g.title} className="w-full h-full object-cover transition-transform group-hover:scale-110" src={g.img} />
              </div>
              <div className="flex flex-col justify-between py-1">
                <div>
                  <h4 className="font-bold text-xl mb-1">{g.title}</h4>
                  <p className="text-sm text-[#9a8d4c]">{g.subtitle}</p>
                </div>
                <div className="flex items-center justify-between mt-4">
                  <div>
                    <p className="text-[10px] text-[#9a8d4c] font-bold uppercase tracking-wider">Starting From</p>
                    <span className="text-xl font-black text-primary">{g.startingFrom}</span>
                  </div>
                  <button className="bg-primary text-white px-5 py-2 rounded-full font-bold text-xs hover:bg-gold-dark transition-all">Book Now</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
